module.exports = __webpack_public_path__ + "media/images/info-gray-1eaf399eb67dfb83185ea4976cfed124.svg";